import { loadPercentage } from "./functions.js";

document.addEventListener("DOMContentLoaded", function (event) {
  let svgRadials = document.querySelectorAll(".radial-progress");

  if (svgRadials) {
    svgRadials.forEach(function (element, index) {
      if (!element.querySelector(".complete").classList.contains("completed")) {
        // Get percentage of progress
        let percent = element.dataset.percentage;

        // Get radius of the svgs circle.complete

        let radius = element.querySelector(".complete").getAttribute("r");

        // Get circumference (2πr)

        let circumference = 2 * Math.PI * radius;

        // Get stroke-dashoffset value based on the percentage of the circumference

        let strokeDashOffset = circumference - (percent * circumference) / 100;

        element.querySelector(".complete").style.strokeDashoffset =
          strokeDashOffset;

        element.querySelector(".complete").classList.add("completed");
      }
    });
  }

  let charProgress = document.querySelectorAll(".info__props__progress_value");

  if (charProgress) {
    loadPercentage(charProgress);
  }

  let newTableProgress = document.querySelectorAll(
    ".new__table__line__stats__item__progress__value"
  );

  if (newTableProgress) {
    loadPercentage(newTableProgress);
  }

  let ratingExtendedProgress = document.querySelectorAll(
    ".infopage__rating__extended__progress span"
  );

  if (ratingExtendedProgress) {
    loadPercentage(ratingExtendedProgress);
  }

  let ratingTableProgress = document.querySelectorAll(
    ".rating__table__stats__item__progress__value"
  );

  if (ratingTableProgress) {
    loadPercentage(ratingTableProgress);
  }
});
